<template lang="html">
<div class="pgInner userFill" :style="'height:' + pageH + 'px;'">
    <el-scrollbar ref="pgScroller" style="height:100%;">

        <div class="pgHead">
            <span>朝企家 | 帐号注册</span>
            <el-button @click="goReturn" class="btn" size="small" type="primary">返回</el-button>
        </div>

        <div class="pgBody" :style="'height:' + (pageH-60) + 'px;'" >
          <div class="btn" @click="register(2)"><el-button type="primary" plain>街乡负责人注册</el-button></div>
          <div class="btn" @click="register(1)"><el-button type="primary" plain>楼宇维护人注册</el-button></div>
        </div>

    </el-scrollbar>

</div>
</template>

<script>
import Cookies from 'js-cookie';
import { paramsCreate } from "@/utils/iparams";
import { requestSmsCode,saveUserRegister } from "@/api/pgMent/userMent";


export default {

    data(){
        return{
            pageH:'',
            pgress:1,
            isWait:false,
            userData:{},
            wTime:0,
           
        }
    },
    methods:{

        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 50;
        },
        register:function(type){
            if(type==1){
                this.$router.push({path:'register',query:{type:1}});
            }
            if(type==2){
                this.$router.push({path:'register',query:{type:2}});
            }
            
        },
      

        goReturn:function(){
            this.$router.go(-1);
        }

    },

    created:function(){
        var vues = this;

        this.userData = this.$store.getters.userInfo;

        this.pageFix();


    }
}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.pgHead{
     height: 60px;
     line-height: 60px;
     padding-left: 30px;
     font-size: 16px;

     .btn{
         float: right;
         width: 80px;
         margin-right: 30px;
         margin-top: 15px;
     }
}

.seek-blcok{
     margin: 0 30px;
     background: white;
     padding: 30px;

     .ttl{
         font-size: 15px;
         font-weight:bold;
     }

     .content{
         margin-top: 20px;
     }

}

.pgBody{
    margin: 0 30px;
    padding: 30px;
    background: white;
    display: flex;
    align-items:center;
   justify-content:center;
    .btn{
         float: right;
         margin-right: 90px;
         margin-top: 15px;
         .el-button{
             height: 120px;
             width: 280px;
         }
     }
}

.disbtn{
    pointer-events: none;
    width: 112px;
}

.userFill .el-form-item{
     display: inline-block;
}

</style>



// WEBPACK FOOTER //
// userRegister.vue?496e1740